import {
  CREATE_PACIENTE_REQUEST,
  CREATE_PACIENTE_SUCCESS,
  CREATE_PACIENTE_FAILURE,
  FETCH_PACIENTES_REQUEST,
  FETCH_PACIENTES_SUCCESS,
  FETCH_PACIENTES_FAILURE,
  FETCH_PACIENTES_EMPRESA_REQUEST,
  FETCH_PACIENTES_EMPRESA_SUCCESS,
  FETCH_PACIENTES_EMPRESA_FAILURE,
  SET_PACIENTES_PAGE,
  SET_PACIENTES_LIMIT,
  UPDATE_PACIENTE_REQUEST,
  UPDATE_PACIENTE_SUCCESS,
  UPDATE_PACIENTE_FAILURE,
  DELETE_PACIENTE_REQUEST,
  DELETE_PACIENTE_SUCCESS,
  DELETE_PACIENTE_FAILURE,
  TOGGLE_VISTA_PACIENTES
} from '../../../constants/pacientes/Paciente';

interface PacientesState {
  pacientes: any[];
  rex_pacientes_options: any[];
  currentPaciente: any | null;
  loading: boolean;
  success: boolean;
  error: string | null;
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
  vistaEmpresa: boolean; // nueva propiedad para controlar si se muestra vista de empresa
  usuarioFiltro: string | null; // ID de usuario para filtrar en vista de empresa
}

const INIT_STATE: PacientesState = {
  pacientes: [],
  rex_pacientes_options: [],
  currentPaciente: null,
  loading: false,
  success: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0
  },
  vistaEmpresa: false,
  usuarioFiltro: null
};

export default (state = INIT_STATE, action: any): PacientesState => {
  switch (action.type) {
    case CREATE_PACIENTE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case CREATE_PACIENTE_SUCCESS:
      const newPaciente = action.payload.paciente;
      const fullName = `${newPaciente.nombre} ${newPaciente.apellidos}`;
      const fullKey = `${newPaciente.cedula}-${fullName}`;
      const newOption = {
        key: fullKey,
        value: newPaciente.id,
        label: `${newPaciente.cedula}-${fullName}`,
        nombre: newPaciente.nombre,
        apellidos: newPaciente.apellidos,
        celular: newPaciente.celular,
        cedula: newPaciente.cedula,
        pacienteId: newPaciente.id,
        searchText: fullName.toLowerCase(),
      };
      return {
        ...state,
        loading: false,
        success: true,
        currentPaciente: action.payload.paciente,
        pacientes: [...state.pacientes, action.payload.paciente],
        rex_pacientes_options: [...state.rex_pacientes_options, newOption],
        pagination: {
          ...state.pagination,
          total: state.pagination.total + 1,
          totalPages: Math.ceil((state.pagination.total + 1) / state.pagination.limit)
        }
      };

    case CREATE_PACIENTE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    case FETCH_PACIENTES_REQUEST:
    case FETCH_PACIENTES_EMPRESA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_PACIENTES_SUCCESS:
    case FETCH_PACIENTES_EMPRESA_SUCCESS:
      const formattedOptions = action.payload.data.map((paciente: any) => {
        const fullName = `${paciente.nombre} ${paciente.apellidos}`;
        const fullKey = `${paciente.cedula}-${fullName}`;
        return {
          key: fullKey,
          value: paciente.id,
          label: `${paciente.cedula}-${fullName}`,
          nombre: paciente.nombre,
          apellidos: paciente.apellidos,
          celular: paciente.celular,
          cedula: paciente.cedula,
          pacienteId: paciente.id,
          searchText: fullName.toLowerCase(),
        }
      });
      return {
        ...state,
        loading: false,
        pacientes: action.payload.data,
        pagination: {
          total: action.payload.meta.total,
          page: action.payload.meta.page,
          limit: action.payload.meta.limit,
          totalPages: action.payload.meta.totalPages
        },
        rex_pacientes_options: formattedOptions
      };

    case FETCH_PACIENTES_FAILURE:
    case FETCH_PACIENTES_EMPRESA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case TOGGLE_VISTA_PACIENTES:
      return {
        ...state,
        vistaEmpresa: action.payload.vistaEmpresa,
        usuarioFiltro: action.payload.usuarioId || null,
        pagination: {
          ...state.pagination,
          page: 1
        }
      };

    case SET_PACIENTES_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.payload
        }
      };

    case SET_PACIENTES_LIMIT:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          limit: action.payload,
          totalPages: Math.ceil(state.pagination.total / action.payload)
        }
      };

    case UPDATE_PACIENTE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case UPDATE_PACIENTE_SUCCESS:
      const updatedPacientes = state.pacientes.map(paciente =>
        paciente.id === action.payload.paciente.id
          ? action.payload.paciente
          : paciente
      );

      return {
        ...state,
        loading: false,
        success: true,
        currentPaciente: action.payload.paciente,
        pacientes: updatedPacientes
      };

    case UPDATE_PACIENTE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    case DELETE_PACIENTE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case DELETE_PACIENTE_SUCCESS:
      const filteredPacientes = state.pacientes.filter(
        paciente => paciente.id !== parseInt(action.payload, 10)
      );

      return {
        ...state,
        loading: false,
        pacientes: filteredPacientes,
        pagination: {
          ...state.pagination,
          total: state.pagination.total - 1,
          totalPages: Math.ceil((state.pagination.total - 1) / state.pagination.limit)
        }
      };

    case DELETE_PACIENTE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};